module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-ivoor-brillenmerk-verpakking-thumbnail.46e3c876.png";